import { getFullDecimalMultiplier } from '@donaswap/utils/getFullDecimalMultiplier'

export const BSC_BLOCK_TIME = 3

// FLAME_PER_BLOCK details
// 40 FLAME is minted per block
// 20 FLAME per block is sent to Burn pool (A farm just for burning flame)
// 10 FLAME per block goes to FLAME pool
// 9 FLAME per block goes to Yield farms and lottery
// FLAME_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// FLAME/Block in src/views/Home/components/FlameDataRow.tsx = 15 (40 - Amount sent to burn pool)
export const FLAME_PER_BLOCK = 40
export const BLOCKS_PER_DAY = (60 / BSC_BLOCK_TIME) * 60 * 24
export const BLOCKS_PER_YEAR = BLOCKS_PER_DAY * 365 // 10512000
export const FLAME_PER_YEAR = FLAME_PER_BLOCK * BLOCKS_PER_YEAR
export const BASE_URL = 'https://donaswap.io'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_URL}/add`
export const DEFAULT_TOKEN_DECIMAL = getFullDecimalMultiplier(18)
export const DEFAULT_GAS_LIMIT = 250000n
export const BOOSTED_FARM_GAS_LIMIT = 500000n
export const BOOSTED_FARM_V3_GAS_LIMIT = 1000000n
export const AUCTION_BIDDERS_TO_FETCH = 500
export const RECLAIM_AUCTIONS_TO_FETCH = 500
export const AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs'
